import { render, staticRenderFns } from "./FakturaBrowse.vue?vue&type=template&id=599a559a"
import script from "./FakturaBrowse.vue?vue&type=script&lang=js"
export * from "./FakturaBrowse.vue?vue&type=script&lang=js"
import style0 from "./FakturaBrowse.vue?vue&type=style&index=0&id=599a559a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports